import styled, { css } from 'styled-components';
const Badge = styled.span`
  padding: 0 4px;
  border-radius: 4px;
  text-transform: capitalize;
  ${({ variant }) =>
    variant === 'gray' &&
    css`
      background-color: var(--accent-color-gray);
      color: var(--accent-color-blue);
    `};
  ${({ variant }) =>
    variant === 'blue' &&
    css`
      background-color: var(--accent-color-blue);
      color: var(--primary-background);
    `};
  ${({ variant }) =>
    variant === 'dark-gray' &&
    css`
      background-color: var(--accent-color-gray);
      color: var(--grey900);
    `};
  ${({ variant }) =>
    variant === 'green' &&
    css`
      background-color: #0fb44b;
      color: #ffffff;
    `};
`;

export default Badge;
